import React, { useState, useEffect, useRef } from "react";
import {
	DesktopOutlined,
	FileOutlined,
	PieChartOutlined,
	TeamOutlined,
	UserOutlined,
} from "@ant-design/icons";
import axios from "axios";
import {
	Form,
	Breadcrumb,
	Layout,
	Menu,
	theme,
	Image,
	Space,
	Flex,
	Spin,
	notification,
} from "antd";
import Logo from "../../../assets/images/MarshalLogo.png";
import Sider from "../../../components/Sider";
import DataTable from "./components/dataSpace";
import SideBar from "./components/sideBar";
import { useParams } from "react-router";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import FastEnters from "../../../components/fastEnters";
import { useTabsGlobal } from "../components/TabsGlobalProvider";
import saveToLocalStorage from "../../../functions/saveToLocalStorage";
import { UserContext } from "../components/privateroute";
import { useContext } from "react";
const { Header, Content, Footer } = Layout;

const Sprawa = () => {
	const scrollBox = useRef(null);
	const [name, setName] = useState("");
	const [posts, setPosts] = useState(null);
	const [ticket, setTicket] = useState(null);
	const [loading, setLoading] = useState(true);
	const [logs, setLogs] = useState([]);
	const [structures, setStructures] = useState([]);
	const [reminders, setReminders] = useState([]);
	const [showLogs, setShowLogs] = useState(false);
	const [reload, setReload] = useState(false);
	const { ticketid, postid } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const isInactiveReadonlyRoute =
		location?.pathname?.startsWith("/sprawy/brak-aktywnosci") ?? false;
	const backPath = isInactiveReadonlyRoute
		? "/sprawy/brak-aktywnosci"
		: "/sprawy";
	const backLabel = isInactiveReadonlyRoute ? "Brak aktywności" : "Sprawy";
	const [areas, setAreas] = useState([]);
	const [special, setSpecial] = useState(null);
	const [specialPeriods, setSpecialPeriods] = useState(null);
	const [loader, setLoader] = useState(false);
	const [uploadedFiles, setUploadedFiles] = useState([]);
	const [newPost, setNewPost] = useState({});
	const [fileList, setFileList] = useState([]);
	const [saveLoading, setSaveLoading] = useState(false);
	const [clear, setClear] = useState(false);
	const doesIdExist = (arr, idToCheck) => {
		return arr.some((item) => item.id === idToCheck);
	};
	const globalUser = useContext(UserContext);

	const isAdmin = Boolean(globalUser?.isadmin);
	const isOwner =
		Number(ticket?.owneruserid) === Number(globalUser?.user?.mlg_users_id);
	const isTicketInactive = Boolean(ticket?.is_inactive);
	const canWriteWhenInactive = Boolean(
		ticket?.can_write_when_inactive ?? (isAdmin || isOwner),
	);
	const isInactiveReadOnly = isTicketInactive && !canWriteWhenInactive;

	const saveCredentialsPost = async (sendType = null) => {
		if (isInactiveReadOnly) {
			notification.error({
				message: "Sprawa tylko do odczytu",
				duration: 3,
			});
			return;
		}
		if (uploadedFiles.length > 0 || newPost.contents != "") {
			setSaveLoading(true);
			const formData = new FormData();
			for (let i = 0; i < uploadedFiles.length; i++) {
				formData.append(`files`, uploadedFiles[i]);
			}
			const newdateline = Math.floor(new Date().getTime() / 1000);
			const response = await axios.post("/sprawa/new/post", {
				credentials: { ...newPost, dateline: newdateline },
				ticketid: ticket,
				sendtype: sendType,
			});
			setTimeout(() => {
				setSaveLoading(false);
			}, 200);
			const postId = response.data.id;
			await axios.post("/sprawa/new/post/files", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
					TicketID: ticket.ticketid,
					PostID: postId,
				},
			});
			setFileList([]);
			setUploadedFiles([]);
			setNewPost({});
			if (response.status == 200) {
				notification.success({
					message: response.data.message,
					duration: 3,
				});
				setClear(true);
			} else {
				notification.error({
					message: response.data.message,
					duration: 3,
				});
			}
		}
		setReload(!reload);
	};

	useEffect(() => {
		let cancelled = false;

		const fetchData = async () => {
			try {
				if (!(Object.keys(globalUser).length > 0)) return;

				// Ensure we don't show mixed old/new ticket data while navigating.
				setLoading(true);
				setLoader(true);
				setName("");
				setTicket(null);
				setPosts(null);
				setReminders(null);
				setSpecial(null);
				setSpecialPeriods(null);
				setStructures([]);
				setLogs([]);
				setAreas([]);

				const [
					responseTicket,
					responseSpecial,
					responseSpecialPeriods,
					responsePosts,
					responseStructures,
					responseLogs,
					responseReminders,
					responseAreas,
				] = await Promise.all([
					axios.post("/sprawa/list/single", {
						id: ticketid,
						userid: globalUser.user.mlg_users_id,
						isadmin: globalUser.isadmin,
					}),
					axios.post("/specialtime/check", {
						ticketid: ticketid,
					}),
					axios.post("/specialtime/get", {
						ticketid: ticketid,
					}),
					axios.post("/sprawa/list/posts", {
						id: ticketid,
					}),
					axios.post("/sprawa/list/structure", {
						ticketid: ticketid,
					}),
					axios.post("/sprawa/get/logs", {
						ticketid: ticketid,
					}),
					axios.post("/sprawa/get/reminders", {
						ticketid: ticketid,
					}),
					axios.post("/sprawa/get/areas", {
						ticketid: ticketid,
					}),
				]);

				if (cancelled) return;

				const loadedTicket = responseTicket.data;
				const loadedPosts = responsePosts.data;
				const loadedTicketInactive = Boolean(loadedTicket?.is_inactive);
				const canWriteInactive =
					!loadedTicketInactive ||
					Boolean(
						loadedTicket?.can_write_when_inactive ??
						(Boolean(globalUser?.isadmin) ||
							Number(loadedTicket?.owneruserid) ===
								Number(globalUser?.user?.mlg_users_id)),
					);

				let finalPosts = loadedPosts;
				if (
					loadedTicketInactive &&
					!canWriteInactive &&
					Array.isArray(loadedPosts) &&
					loadedPosts.length > 0
				) {
					const oldest = loadedPosts[0];
					const newest = loadedPosts[loadedPosts.length - 1];
					finalPosts =
						oldest?.ticketpostid === newest?.ticketpostid
							? [oldest]
							: [oldest, newest];

					if (postid) {
						const allowed = finalPosts.map((p) =>
							String(p?.ticketpostid),
						);
						if (
							!allowed.includes(String(postid)) &&
							allowed.length > 0
						) {
							navigate(
								`${backPath}/${ticketid}/${
									allowed[allowed.length - 1]
								}`,
								{ replace: true },
							);
						}
					}
				}

				setSpecial(responseSpecial.data);
				setSpecialPeriods(responseSpecialPeriods.data);
				setTicket(loadedTicket);
				setName(loadedTicket.subject);
				setPosts(finalPosts);
				setStructures(responseStructures.data);
				setLogs(responseLogs.data);
				setReminders(responseReminders.data);
				setAreas(responseAreas.data);
			} catch (error) {
				if (cancelled) return;
				if (error.response) {
					notification.error({
						message: error.response.data.message,
						duration: 3,
					});
					navigate(backPath);
				}
			} finally {
				if (cancelled) return;
				setLoader(false);
				setLoading(false);
			}
		};

		fetchData();
		return () => {
			cancelled = true;
		};
	}, [ticketid, reload, globalUser]);
	return (
		<>
			<Breadcrumb
				style={{
					padding: "20px",
				}}
			>
				<Breadcrumb.Item>Strona główna</Breadcrumb.Item>
				<Breadcrumb.Item onClick={() => navigate(backPath)}>
					<span style={{ cursor: "pointer" }}>{backLabel}</span>
				</Breadcrumb.Item>
				<Breadcrumb.Item>{name}</Breadcrumb.Item>
			</Breadcrumb>
			<FastEnters></FastEnters>
			<Form
				layout="vertical"
				name="ticket"
			>
				<Spin spinning={loading}>
					<Flex
						className={["fullHeight"]}
						align="start"
						style={{
							gap: "0px",
							width: "100%",
							background: "white",
							height: "calc(-175px + 100vh)",
						}}
					>
						{ticket != null &&
						posts != null &&
						reminders != null &&
						special != null &&
						specialPeriods != null ? (
							<>
								<DataTable
									saveCredentialsPost={saveCredentialsPost}
									clear={clear}
									setClear={setClear}
									setSaveLoading={setSaveLoading}
									saveLoading={saveLoading}
									fileList={fileList}
									setFileList={setFileList}
									newPost={newPost}
									setNewPost={setNewPost}
									uploadedFiles={uploadedFiles}
									setUploadedFiles={setUploadedFiles}
									readOnly={isInactiveReadOnly}
									structures={structures}
									setStructures={setStructures}
									postid={postid}
									specialPeriods={specialPeriods}
									setReminders={setReminders}
									reminders={reminders}
									showLogs={showLogs}
									setShowLogs={setShowLogs}
									scrollBox={scrollBox}
									reload={reload}
									setReload={setReload}
									ticket={ticket}
									setTicket={setTicket}
									posts={posts}
									setPosts={setPosts}
									logs={logs}
								/>
								<SideBar
									saveCredentialsPost={saveCredentialsPost}
									loader={loader}
									setLoader={setLoader}
									special={special}
									setSpecial={setSpecial}
									areas={areas}
									setAreas={setAreas}
									setReload={setReload}
									reload={reload}
									showLogs={showLogs}
									setShowLogs={setShowLogs}
									ticket={ticket}
									setTicket={setTicket}
									posts={posts}
									setPosts={setPosts}
									readOnly={isInactiveReadOnly}
									backPath={backPath}
								/>
							</>
						) : (
							<></>
						)}
					</Flex>
				</Spin>
			</Form>
		</>
	);
};
export default Sprawa;
